module.exports = __webpack_public_path__ + "img/lb.20432003.png";